"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardStatus = void 0;
/// <reference path="../../typings/.d.ts" />
var WizardStatus;
(function (WizardStatus) {
    WizardStatus["New"] = "New";
    WizardStatus["Edit"] = "Edit";
    WizardStatus["None"] = "None";
})(WizardStatus = exports.WizardStatus || (exports.WizardStatus = {}));
